<div class="auth-wrapper">
  <div class="testimonial-div">
    <div class="my-4">
      <h3 class="text-gray lh-50">
        join other businesses who enjoy <br />
        <b>cheaper FX rates, faster settlement periods &amp; liquidity</b>
      </h3>
    </div>
    <div class="my-4">
      <div class="d-flex align-items-center mt-1-25 mb-5">
        <img
          src="assets/images/smartphone.svg"
          alt="smartphone"
          class="flash-icon" />
        <div class="ms-4">
          <p class="h5 text-gray mb-0">enter the <b>verification code</b></p>
          <p class="text-gray mb-0">
            we have sent a code on your registered email
          </p>
        </div>
      </div>
      <div class="d-flex align-items-center mb-5">
        <img
          src="assets/images/long-term.svg"
          alt="long-term"
          class="flash-icon" />
        <div class="ms-4">
          <p class="h5 text-gray mb-0">did <b>not receive</b> code?</p>
          <p class="text-gray mb-0">
            click on <b>resend otp</b> button or contact us on
            <a href="mailto:platform@xbp.com" class="auth-hyperlink">
              XBP Support
            </a>
            for further assistance.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="form-div">
    <img src="" class="logo mb-5" alt="" />
    <p class="text-gray h3 mb-2">2-Step <b>verification</b></p>
    <p class="text-gray mb-4">
      To ensure your account safety, XBP wants to make sure it's really you.
    </p>
    <form
      [formGroup]="verifyOTP"
      (ngSubmit)="onVerifyOTPSubmit()"
      autocomplete="off">
      <app-auth-input
        [inputData]="attributeConstant.verification_code"
        [formControlName]="attributeConstant.verification_code.key">
      </app-auth-input>
      <button class="btn primary-btn w-100 mt-1-25">Verify</button>
    </form>
  </div>
</div>
